import { render, staticRenderFns } from "./bidClarification.vue?vue&type=template&id=dcae9bfe&scoped=true"
import script from "./bidClarification.vue?vue&type=script&lang=js"
export * from "./bidClarification.vue?vue&type=script&lang=js"
import style0 from "./bidClarification.vue?vue&type=style&index=0&id=dcae9bfe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcae9bfe",
  null
  
)

export default component.exports